// extracted by mini-css-extract-plugin
export default {"mainContainer":"About_mainContainer__cYvFL"};